import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconName, IconNames } from '@navstation-portal/shared/data-model/ui';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { TooltipModule } from 'primeng/tooltip';

export type InfoTooltipVariant = 'info' | 'warning';

const VARIANT_ICON: Record<InfoTooltipVariant, IconName> = {
  info: IconNames.CircleInfo,
  warning: IconNames.ExclamationTriangle,
};

const VARIANT_COLOR_CLASS: Record<InfoTooltipVariant, string> = {
  info: 'text-(--content-neutral-secondary)',
  warning: 'text-(--content-warning-primary)',
};

@Component({
  selector: 'nsp-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipModule],
})
export class InfoTooltipComponent {
  text = input.required<string>();
  variant = input<InfoTooltipVariant>('info');
  visible = input(true);

  readonly iconName = computed(() => VARIANT_ICON[this.variant()]);
  readonly colorClass = computed(() => VARIANT_COLOR_CLASS[this.variant()]);
}
